/**
 * Commander name persistence (GDD-v3 §2.2 — immersion only).
 *
 * The name is never a gate: empty/whitespace input resolves silently to the
 * default. There is deliberately no profanity filter, format enforcement, or
 * error state — those guard public multiplayer, which does not apply here.
 */

export const DEFAULT_COMMANDER_NAME = 'Commander'
export const MAX_COMMANDER_NAME_LENGTH = 15

const STORAGE_KEY = 'fleetduel-commander-name'

/** Trim whitespace and cap length; empty resolves to the default name. */
export function normalizeCommanderName(raw: string): string {
  const trimmed = raw.trim().slice(0, MAX_COMMANDER_NAME_LENGTH).trim()
  return trimmed.length === 0 ? DEFAULT_COMMANDER_NAME : trimmed
}

/** Returns the persisted name, or null on a first visit (shows the overlay). */
export function loadCommanderName(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

/** Persists the normalized name and returns it. */
export function saveCommanderName(raw: string): string {
  const name = normalizeCommanderName(raw)
  try {
    localStorage.setItem(STORAGE_KEY, name)
  } catch {
    // Storage unavailable — the name still applies for this session.
  }
  return name
}
